module.exports = __webpack_public_path__ + "img/choose2.b63d1d87.png";